import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import routes from './router';
// import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(routes, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js